const FOLDED_HEIGHT = "20px";
const DURATION = 120;

// used for setting height of boxes...
let topBoxes: { [key: number]: HTMLDivElement[] } = {};

// used for event listener unsub...
let unsubs: (() => void)[] = [];
export function foldOutCards() {
  // This will unsub all event listeners on each subsequent call...
  unsubs.forEach((x) => x());
  // Reset those for next round...
  unsubs = [];
  topBoxes = {};

  document.querySelectorAll(".pipechain-fold-out-cards__card").forEach((el) => {
    const openButton = el.querySelector(
      ".pipechain-fold-out-cards__open-button"
    ) as HTMLButtonElement;
    const foldOutContent = el.querySelector(
      ".pipechain-fold-out-cards__fold-out-content"
    ) as HTMLDivElement;
    const closeButton = el.querySelector(
      ".pipechain-fold-out-cards__close-button"
    ) as HTMLButtonElement;

    const topContent = el.querySelector(
      ".pipechain-fold-out-cards__top-content"
    ) as HTMLDivElement;

    // Add those to set height later!
    if (!(topContent.offsetTop in topBoxes))
      topBoxes[topContent.offsetTop] = [];
    topBoxes[topContent.offsetTop].push(topContent);

    function toggleOpacity(el: Element, onOff: boolean) {
      el.classList.toggle("opacity-0", !onOff);
      el.classList.toggle("opacity-100", onOff);
    }

    function open() {
      console.log("open click!");
      toggleOpacity(openButton, false);
      openButton.classList.add("pointer-events-none");
      toggleOpacity(foldOutContent, false);
      const heightTarget = foldOutContent.dataset["targetHeight"];
      foldOutContent.style.height = FOLDED_HEIGHT;
      setTimeout(() => {
        foldOutContent.style.height = heightTarget as string;
        setTimeout(() => {
          foldOutContent.style.height = ``;
          foldOutContent.dataset[
            "targetHeight"
          ] = `${foldOutContent.offsetHeight}px`;
          toggleOpacity(foldOutContent, true);
        }, DURATION);
      }, DURATION);
    }

    openButton?.addEventListener("click", open);

    function close() {
      const currentHeight = foldOutContent.offsetHeight;
      foldOutContent.style.height = `${currentHeight}px`;
      toggleOpacity(foldOutContent, false);
      setTimeout(() => {
        foldOutContent.style.height = FOLDED_HEIGHT;
        setTimeout(() => {
          // foldOutContent.classList.add("hidden");
          toggleOpacity(openButton, true);
          openButton.classList.remove("pointer-events-none");
        }, DURATION);
      }, DURATION);
    }

    closeButton?.addEventListener("click", close);

    // close all of them, store their target height in DOM
    foldOutContent.dataset["targetHeight"] = `${foldOutContent.offsetHeight}px`;
    foldOutContent.style.height = FOLDED_HEIGHT;
    unsubs.push(() => {
      openButton.removeEventListener("click", open);
      closeButton.removeEventListener("click", close);
      // Also close any boxes...
      close();
    });
  });

  // Set height...
  setTimeout(() => {
    for (const key in topBoxes) {
      let maxHeight = 0;
      for (const box of topBoxes[key])
        maxHeight = Math.max(maxHeight, box.offsetHeight);
      for (const box of topBoxes[key]) {
        box.style.height = `${maxHeight}px`;
      }
    }
    unsubs.push(() => {
      for (const key in topBoxes) {
        for (const box of topBoxes[key]) {
          box.style.height = ``;
        }
      }
    });
  });
}
